import MaterialTable, { MTableToolbar } from "@eataly/material-table";
import { TablePagination } from "@mui/material";
import { Grid } from "@material-ui/core";

function DataTablePaginationServer({
  footerData,
  title,
  columns,
  data,
  filtering,
  width,
  exportFileName,
  selection,
  parentChildData,
  onSelectionChange,
  selectionProps,
  exportButton,
  onChangePage,
  onChangeRowsPerPage,
  countRowData,
  tableRef,
  pageSize,
  page,
  totalCount,
  onSearchChange,
  detailPanel,
  onRowClick
}) {
  
  return (
    <>
      <div style={{ width: width ? width : "100%" }}>
        <MaterialTable
          onSearchChange={onSearchChange}
          tableRef={tableRef}
          footerData={footerData ? footerData : []}
          components={{
            Container: (prop) => <div>{prop.children}</div>,
            Toolbar: (props) => {
              const propsCopy = {...props };
              propsCopy.showTitle = false;
              return (
                <Grid container direction="row" spacing={0}>
                  <Grid item xs={8} style={{ marginTop: "5px" }}>
                    {title}
                  </Grid>
                  <Grid item xs={4}>
                    {exportButton ? <MTableToolbar {...propsCopy} /> : null}
                  </Grid>
                </Grid>
              );
            },
            Pagination: (props) => {
              return (
                <TablePagination
                  component="div"
                  count={totalCount}
                  page={page}
                  onPageChange={onChangePage}
                  showFirstButton={true}
                  labelRowsPerPage={<label>แสดง</label>}
                  labelDisplayedRows={({ from, to, count }) =>
                    <label>{`${from} - ${to} จากทั้งหมด ${count}`}</label>
                  }
                  showLastButton={true}
                  rowsPerPage={pageSize}
                  onRowsPerPageChange={onChangeRowsPerPage}
                  rowsPerPageOptions={[25, 50]}
                />
              );
            },
          }}
          onRowClick={onRowClick}
          detailPanel={detailPanel}
          columns={columns}
          data={data}
          page={page}
          totalCount={totalCount}
          parentChildData={parentChildData}
          onSelectionChange={onSelectionChange}
          // onChangeRowsPerPage={onChangeRowsPerPage}
          options={{
            defaultExpanded: true,
            selection: selection,
            filtering: filtering,
            paginationPosition: "bottom",
            search: true,
            exportButton: exportButton,
            padding: "dense",
            rowStyle: {
              height: "10px !important",
              fontSize: "8px !important",
              fontFamily: "sans-serif",
              whiteSpace: 'nowrap',
              fontFamily: "Sarabun",
            },
            searchFieldStyle: {
              fontFamily: "sans-serif",
            },
            // searchFieldVariant: 'variant',
            // fixedColumns: {
            //   left: 2,
            //   right: 0
            // },
            tableLayout: "fixed",
            columnResizable: true,
            toolbar: false,
            headerStyle: {
              // background: "linear-gradient(180deg, #406ADD 0%, #0D47A1 100%)",
              color: "#0D47A1",
              fontSize: "14px",
              textAlign: "start",
              whiteSpace: "nowrap",
              fontFamily: "Sarabun",
              height: "5px",
            },
            maxBodyHeight: "75vh",
            // pageSizeOptions: [1, 5, 150, 200],
            pageSize: pageSize,
            emptyRowsWhenPaging: false,
            exportFileName: exportFileName,
          }}
          localization={{
            body: {
              emptyDataSourceMessage: <label style={{color: '#0D47A1'}}>ไม่พบข้อมูล</label>,
            },
            toolbar: {
              searchPlaceholder: "ค้นหา",
              exportTitle: "ส่งออก Excel",
              exportName: "ส่งออก Excel",
            },
            // pagination:{
            //   labelRowsSelect: 'แสดง',
            //   firstTooltip: 'หน้าแรก',
            //   previousTooltip: 'หน้าที่แล้ว',
            //   nextAriaLabel: 'หน้าต่อไป',
            //   nextTooltip: 'หน้าต่อไป',
            //   lastAriaLabel: 'หน้าที่แล้ว',
            //   lastTooltip: 'หน้าสุดท้าย',
            //   labelDisplayedRows: `{from}-{to} จาก ${countRowData}`
            // }
          }}
        />
      </div>
    </>
  );
}

export default DataTablePaginationServer;
